<template>
  <div class="articles">
    <div id="currentCategory">{{this.$route.params.category}}</div>
    <masonry-wall :items="articles" :column-width="200" :gap="25">
      <template v-slot:default="{item}">
        <div class="Item">
          <a :href=item.link target="_blank">
            <div class="Content">
                <i>{{item.title}}</i>, {{item.date | formatDate}}
            </div>
            <img :src="item.photo"/>
          </a>
        </div>
      </template>
    </masonry-wall>
    <ScrollToTopButton />
  </div>
</template>

<script>
import { requestsMixin } from '../mixins/requestsMixin'
import MasonryWall from '@yeger/vue2-masonry-wall'
import ScrollToTopButton from '@/components/ScrollToTopButton.vue'

export default {
  name: 'WorksGallery',
  components: {
    MasonryWall,
    ScrollToTopButton
  },
  data () {
    return {
      articles: [
        // {
        //   title: 'Breve crónica disfuncional de un encargo de traducción», nº 53',
        //   link: 'https://vasoscomunicantes.ace-traductores.org/2020/06/22/breve-cronica-disfuncional-de-una-traduccion-julia-osuna/',
        //   photo: 'http://camerino.lamujercambiante.es/img/works/158.jpg',
        //   date: '22 de junio de 2020'
        // }
      ]
    }
  },
  mixins: [requestsMixin],
  methods: {
    showWorks (category) {
      console.log('Showing category ' + category)
      this.category = category
      this.page = 1
      this.works = []
      this.downloadWorks()
    },
    downloadWorks: function () {
      this.fetchArticles(this.category, this.page).then(value => value.forEach(i => this.articles.push(i)))
      this.page = this.page + 1
    }
  },
  mounted () { // Method called the first time the gallery is loaded
    this.showWorks(this.$route.params.category)
  }
  // updated () { // Method called when re-entering the gallery component
  //   const category = this.$route.params.category
  //   if (category !== undefined && this.category !== category) {
  //     this.showWorks(category)
  //   }
  // },
  // beforeRouteUpdate (to, from, next) { // Method called when the category is changed
  //   this.showWorks(to.params.category)
  //   next()
  // }
}
</script>

<style scoped lang="scss">
  .articles {
    padding: 5px;
    margin-top: 50px;
    // margin-left: 5%;
    // margin-right: 5em;
  }

  .Item {
    overflow: hidden;
    border-radius: 5px;
    // width: 100%;
    // margin: 0px;
    margin: 5px;
    padding: 0px;
    filter: drop-shadow(0px 0px 6px #666666);
    background-color: rgba(255, 255, 255, 0.6);
  }
  .Item a {
    text-decoration: none;
    color:#69303e;
  }
  .Content {
    padding-top: 3px;
    padding-bottom: 0px;
    padding-right: 5px;
    padding-left: 5px;
    line-height: 140%;
  }
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    line-height: 0;
    display: block;
  }
  #currentCategory {
    visibility: hidden;
    display: none;
  }
  .masonry-column {
    margin: 10px;
    padding: 10px;
  }
  .masonry-item {
    margin: 10px;
    padding: 10px;
  }

  // @include respond-above(xs) {
  //   .works {
  //     margin-left: 3%;
  //     margin-right: 3%;
  //   }
  // }

  @include respond-above(md) {
    .articles {
      padding: 0px;
      margin-left: 200px;
      margin-right: 200px;
    }
    .Item {
    margin: 5px;
    }
  }

  // @include respond-above(lg) {
  //   .works {
  //     margin-left: 3%;
  //     margin-right: 3%;
  //   }
  // }

</style>
